import { useNavigationBlockerViaHistory } from '@libs/hooks';
import { isFailed, isShowLoader, useAppSelector } from '@libs/store';
import { AssetsSvgMap } from '@libs/types';
import { ConditionalRender } from '@libs/utils';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { CommonScreen } from './common/CommonScreen/CommonScreen';
import styled from './widgetWrapper.module.css';

export const WidgetWrapper = ({ children }: { children: React.ReactNode }) => {
    const isLoader = useAppSelector(isShowLoader);
    const isStatusFlailed = useAppSelector(isFailed);
    const navigate = useNavigate();

    useNavigationBlockerViaHistory(true);

    useEffect(() => {
        if (isLoader) {
            // @ts-expect-error
            document?.activeElement?.blur?.();
        }
    }, [isLoader]);

    return (
        <>
            <ConditionalRender condition={isStatusFlailed}>
                <CommonScreen
                    useIcon={false}
                    fill="pink_100"
                    iconName={AssetsSvgMap.ic_x_circle_thin_80}
                    mainText="Something went wrong..."
                    buttonLabel="Try again"
                    buttonHandleClick={() => {
                        navigate('/clearSession');
                    }}
                />
            </ConditionalRender>
            <ConditionalRender condition={isLoader}>
                <div className={styled.overlayContainer}>
                    <ConditionalRender condition={isLoader} delay={800}>
                        <CommonScreen useBackground={false} useSpinner={true} />
                    </ConditionalRender>
                </div>
            </ConditionalRender>
            <ConditionalRender condition={!isStatusFlailed}>{children}</ConditionalRender>
        </>
    );
};
